import { render, staticRenderFns } from "./indexTab2.vue?vue&type=template&id=4d90597c&scoped=true&"
import script from "./indexTab2.vue?vue&type=script&lang=js&"
export * from "./indexTab2.vue?vue&type=script&lang=js&"
import style0 from "./indexTab2.vue?vue&type=style&index=0&id=4d90597c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90597c",
  null
  
)

export default component.exports